module.exports = __webpack_public_path__ + "static/media/fa-light-300d41d.c72987d0.eot";